export default __webpack_public_path__ + "static/media/strawberry.0b7976c5.jpg";